import { trace } from '../../../configuration/setup/trace';

export const MAP_CHANGED_EVENT = 'EVENT_MAP_CHANGED';

export const mapChangedHandler = (data: string) => {
    trace.debug('Map changed:', data);
};
